import { render, staticRenderFns } from "./balticDryIndex.vue?vue&type=template&id=4c3d8be5&scoped=true"
import script from "./balticDryIndex.vue?vue&type=script&lang=js"
export * from "./balticDryIndex.vue?vue&type=script&lang=js"
import style0 from "./balticDryIndex.vue?vue&type=style&index=0&id=4c3d8be5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3d8be5",
  null
  
)

export default component.exports